import { createReducer, on } from '@ngrx/store';
import * as BizActions from './biz-category.action';
import { BizCategory } from '../../models/biz-category';

export interface BizCategoryState {
  bizCategory: BizCategory[] | any;
  loading: boolean;
  error: any;
}

export const initialState: BizCategoryState = {
  bizCategory: [],
  loading: false,
  error: null,
};

export const bizCategoryReducer = createReducer(
  initialState,
  on(BizActions.loadBizCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(BizActions.loadBizCategorySuccess, (state, { bizCategory }) => ({
    ...state,
    bizCategory,
    loading: false,
  })),
  on(BizActions.loadBizCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);